import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, formValueSelector, change } from 'redux-form';
import { Row } from "react-foundation";

import Loading from "../../../components/Loading";
import SlickSlider from "../../../components/SlickSlider";
import ImageResolver from "../../ImageResolver.js";
import Tick from "../../../components/Tick";
import { addPreviousPreviews } from "./../../../actions";
import InputError from "../../../components/InputError";
import { fetchPreviewUrls, updatePreviousSelection } from '../../../actions';
import ThemeButton from "../../../components/ThemeButton";
import { getDoorStyles } from "../../../actions/door";
import SeparatingLine from "../../../components/SeparatingLine";
import FormWrapper from "../../FormWrapper";
import FormHeader from "../../../components/FormHeader";

class SelectGlass extends Component {
    renderGlass(value, index) {
        let selectedClass = value.id === this.props.input.value ? "selected" : "";

        return (
            <div key={index} className={selectedClass} style={{ display: "inline-block" }}>
                <div className="slick-slide-image-container">
                    <Tick />
                    <ImageResolver key={value.id} filters={{ styleId: value.id }} />
                </div>
                <p className={"slick-slide-title"}>{value.name}</p>
            </div>
        );
    }

    render() {
        let { glasses, input, addPreviousPreviews } = this.props;

        if (glasses.length === 0) {
            return <Loading />;
        }

        return (
            <div>
                <Row isColumn>
                    <SlickSlider
                        values={glasses}
                        selectedId={input.value}
                        onDisplay={this.renderGlass.bind(this)}
                        onChange={id => {
                            addPreviousPreviews({ styleId: id }, [4]);
                            input.onChange(id);
                        }}
                    />
                </Row>
                <InputError metas={this.props.meta} />
            </div>
        );
    }
}

class GlassForm extends Component {
    componentDidMount() {
        this.props.getDoorStyles(this.props.doorStyles[0].productId);
        this.props.fetchPreviewUrls({ styleid: this.props.doorStyleId, slabExtraId: this.props.doorExteriorColourId }, true);
    }

    componentDidUpdate() {
        let { selectedGlass, glasses, hasPreviewImages, dispatch, previousSelection, addPreviousPreviews } = this.props;

        if (!selectedGlass.id && hasPreviewImages) {
            if (glasses.length > 0) {
                // do something
                var exists = previousSelection.DoorCompositeGlassId && glasses.findIndex(glass => glass.id === previousSelection.DoorCompositeGlassId) !== -1;

                var glassId = exists ? previousSelection.DoorCompositeGlassId : glasses[0].id;

                addPreviousPreviews({ styleId: glassId }, [4]);
                dispatch(change("DoorWizard", "DoorGlassId", glassId));
            }
        }
    }

    onSubmit(values) {

        this.props.updatePreviousSelection({
            DoorCompositeGlassId: values.DoorGlassId
        });

        this.props.onSubmit(values);
    }

    render() {
        return (
            <form className="GlassForm composite" onSubmit={this.props.handleSubmit(this.onSubmit.bind(this))}            >
                <FormHeader title={"Glass"} subtitle={""} />

                <SeparatingLine />

                <FormWrapper>
                    <Field
                        name="DoorGlassId"
                        component={SelectGlass}
                        glasses={this.props.glasses}
                        addPreviousPreviews={this.props.addPreviousPreviews}
                    />
                </FormWrapper>

                <div className="button-panel">
                    <SeparatingLine />
                    <button className="button back" type="button" onClick={this.props.previousPage}>
                        Back
                    </button>
                    <ThemeButton className="next">Next</ThemeButton>
                </div>
            </form>
        );
    }
}

const mapStateToProps = state => {
    let valueSelector = formValueSelector("DoorWizard");
    let doorStyleId = valueSelector(state, "DoorStyleId") || 171;
    let doorExteriorColourId = valueSelector(state, "DoorExteriorColourId") || 31;
    let doorGlassId = valueSelector(state, "DoorGlassId");

    let doorStyles = state.Door.Styles;

    let doorStyle = doorStyles.filter(s => s.id === doorStyleId)[0] || {};

    doorStyles = doorStyles.filter(
        s => s.groupingHierarchy2.key === doorStyle.groupingHierarchy2.key
    );

    let selectedGlass = doorStyles.filter(c => c.id === doorGlassId)[0] || {};

    return {
        glasses: doorStyles,
        doorStyleId,
        doorExteriorColourId,
        doorStyles,
        hasPreviewImages: state.PreviewImages.length > 0,
        selectedGlass,
        previousSelection: state.PreviousSelection
    };
};

export default connect(mapStateToProps, { fetchPreviewUrls, addPreviousPreviews, getDoorStyles, updatePreviousSelection })(
    GlassForm
);



// WEBPACK FOOTER //
// ./src/containers/DoorForm/composite/GlassForm.js